<template>
<!-- 所有题型右上角编辑区 -->
  <div class="custom-edit-box" :style="{'z-index':dv?'2000':'3000'}">
    <el-button type="primary" icon="el-icon-edit-outline" circle size="small" @click.stop="edit"></el-button>
    <el-button type="primary" icon="el-icon-delete" circle size="small" @click.stop="del"></el-button>
    <el-popover
      placement="bottom"
      width="170"
      trigger="click"
      style="margin-left:10px;"
      v-model="popoverVisible"
      :disabled="isDis"
    >
      <div class="popover-cont">
        <template v-if="msg.types==1">
          <p>
            <span class="popo-text">每组题数</span>
            <el-input-number
              v-model="objectiveForm.rowNum"
              controls-position="right"
              :min="1"
              :max="10"
              size="mini"
              style="width:100px;"
            ></el-input-number>
          </p>
          <p>
            <span class="popo-text">排列方向</span>
            <el-select
              v-model="objectiveForm.diffLayout"
              placeholder="请选择"
              size="mini"
              style="width:100px;"
            >
              <el-option label="横排" :value="false"></el-option>
              <el-option label="竖排" :value="true"></el-option>
            </el-select>
          </p>
        </template>
        <template v-if="msg.types==2">
          <p class="line">
            <span class="popo-text">作答长度</span>
            <el-select
              v-model="fillForm.rowNum"
              placeholder="请选择"
              size="mini"
              style="width:100px;"
              @change="fillRowNum(true)"
            >
              <el-option label="1/4" :value="0.4"></el-option>
              <el-option label="1/3" :value="0.3"></el-option>
              <el-option label="1/2" :value="0.2"></el-option>
              <el-option label="1" :value="1"></el-option>
              <el-option label="2" :value="2"></el-option>
            </el-select>
          </p>
          <div style="max-height:130px;overflow-y:auto;padding-top:15px;">
            <p v-for="(fill,i) in fillForm.list" :key="'fill'+i">
              <span class="popo-text">{{fill.tihao}}</span>
              <el-select v-model="fill.rowNum" placeholder="请选择" size="mini" style="width:100px;" @change="fillRowNum(false)">
                <el-option label="1/4" :value="0.4"></el-option>
                <el-option label="1/3" :value="0.3"></el-option>
                <el-option label="1/2" :value="0.2"></el-option>
                <el-option label="1" :value="1"></el-option>
                <el-option label="2" :value="2"></el-option>
              </el-select>
            </p>
          </div>
        </template>
        <template v-if="msg.types==3||msg.types==4||msg.types==6">
          <p>
            <span class="popo-text">行数</span>
            <el-input-number
              v-model="form346.rowNum"
              controls-position="right"
              :min="1"
              :max="100"
              size="mini"
              style="width:100px;"
            ></el-input-number>
          </p>
          <p>
            <span class="popo-text">样式</span>
            <el-select
              v-model="form346.sty"
              placeholder="请选择"
              size="mini"
              style="width:100px;"
              @change="fillRowNum(true)"
            >
              <el-option label="无" :value="0"></el-option>
              <el-option label="单行线" :value="1"></el-option>
              <!-- <el-option label="四线三格" :value="2"></el-option> -->
            </el-select>
          </p>
        </template>
        <template v-if="msg.types==5">
          <p>
            <span class="popo-text">字数</span>
            <el-input-number
              v-model="writingForm.rowNum"
              controls-position="right"
              :min="1000"
              :max="2000"
              size="mini"
              style="width:100px;"
            ></el-input-number>
          </p>
          <p>
            <span class="popo-text">字数提示</span>
            <el-select
              v-model="writingForm.isNumPos"
              placeholder="请选择"
              size="mini"
              style="width:100px;"
              @change="fillRowNum(true)"
            >
              <el-option label="显示" :value="1"></el-option>
              <el-option label="不显示" :value="0"></el-option>
            </el-select>
          </p>
        </template>
        
        <p style="text-align:right;">
          <el-button type="text" size="mini" @click="closePopover">取消</el-button>
          <el-button type="primary" size="mini" @click="submitPopover">确定</el-button>
        </p>
      </div>
      <el-button slot="reference" type="primary" icon="el-icon-s-operation" circle size="small" :disabled="isDis"></el-button>
    </el-popover>
    <!-- <objective-box v-if="objectiveDV" :isShow.sync="objectiveDV" :isEdit="true" :allIndex="allIndex"/>
    <fill-box v-if="fillDV" :isShow.sync="fillDV" :isEdit="true" :allIndex="allIndex" />
    <answer-box v-if="answerDV" :isShow.sync="answerDV" :isEdit="true" :allIndex="allIndex" /> -->
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import ObjectiveBox from "@/components/TopicMakeBox/ObjectiveBox";
import FillBox from "@/components/TopicMakeBox/FillBox";
import AnswerBox from "@/components/TopicMakeBox/AnswerBox";
import cardOperate from "@/assets/js/utils/cardOperate";
export default {
  name: "CustomEdit",
  // components: { ObjectiveBox, FillBox,AnswerBox },
  props: {
    msg: Object,
    isDis:Boolean,
    gi:null,
  },
  computed: {
    ...mapState("cardMake", {
      topicStoreroom: state => state.topicStoreroom,
      objectiveDV: state => state.objectiveDV, 
      fillDV: state => state.fillDV,  
      answerDV: state => state.answerDV,  
      chooseDV: state => state.chooseDV,  
      writingEnDV: state => state.writingEnDV,  
      writingDV: state => state.writingDV,   
    }),
    allIndex() {
      let curIndex = {
        pageIndex: this.msg.pageIndex,
        topicIndex: this.msg.topicIndex,
        topicInPageIndex: this.msg.topicInPageIndex
      };
      return curIndex;
    },
    dv(){
      if(this.objectiveDV||this.fillDV||this.answerDV||this.chooseDV||this.writingEnDV||this.writingDV){
        return true
      }else{
        return false
      }
    },
  },
  data() {
    return {
      popoverVisible: false,
      objectiveForm: {
        rowNum: 5,
        diffLayout: false
      },
      fillForm: {
        rowNum: null,
        list: []
      },
      form346:{
        rowNum:8,
        sty:0
      },
      writingForm:{
        rowNum:1000,
        isNumPos:1
      },
      isFillChange:false,
    };
  },
  mounted() {
    if (this.msg.types == 1){
      this.objectiveForm.rowNum = this.topicStoreroom[this.msg.topicIndex].typesItem.rowNum;
      this.objectiveForm.diffLayout = this.topicStoreroom[this.msg.topicIndex].typesItem.diffLayout;
    }
    if (this.msg.types == 2) {
      this.fillForm.rowNum = this.msg.typesItem.rowNum;
      this.msg.typesItem.list.forEach(fill => {
        let curFill = {
          tihao: fill.tihao,
          rowNum: fill.rowNum
        };
        this.fillForm.list.push(curFill);
      });
    }
    
      if(this.msg.types == 4){
        this.form346.rowNum=this.msg.typesItem.rowNum
        this.form346.sty=this.msg.typesItem.sty
      }else if (this.msg.types == 3&&this.msg.types == 6){
        this.form346.rowNum=this.msg.typesItem.groupNum[this.gi].groupNum
        this.form346.sty=this.msg.typesItem.groupNum[this.gi].sty
      }
      
    
    if (this.msg.types == 5){
      this.writingForm.rowNum=this.msg.typesItem.rowNum
      this.writingForm.isNumPos=this.msg.typesItem.isNumPos
    }
  },
  methods: {
    ...mapMutations({
      objectiveFromMut: "cardMake/objectiveFromMut",
      boxLoadingMut:"cardMake/boxLoadingMut",
      objectiveDVMut: "cardMake/objectiveDVMut",
      fillDVMut: "cardMake/fillDVMut",
      answerDVMut: "cardMake/answerDVMut",
      chooseDVMut: "cardMake/chooseDVMut",
      writingEnDVMut: "cardMake/writingEnDVMut",
      writingDVMut: "cardMake/writingDVMut",
      isBoxEditMut: "cardMake/isBoxEditMut",
      allIndexMut: "cardMake/allIndexMut",
    }), //参数的变动
    // ...mapActions({
    //   editPageData: "cardMake/editPageData"
    // }), //参数的变动
    fillRowNum(v) {
      this.isFillChange=true
      if(v){
        this.fillForm.list.forEach(fill => {
        fill.rowNum = this.fillForm.rowNum;
      });
      }
      
    },
    edit() {
      this.isBoxEditMut(true)
      this.allIndexMut(this.allIndex)
      switch (this.msg.types) {
        case 1:
          this.objectiveDVMut(true)
          break;
        case 2:
          this.fillDVMut(true)
          break;
        case 3:
          this.answerDVMut(true)
          break;
        case 4:
          this.writingEnDVMut(true)
          break;
        case 5:
           this.writingDVMut(true)
          break;
        case 6:
         this.chooseDVMut(true)
          break;
      }
      this.boxLoadingMut(true);
    },
    del() {
      this.$confirm("删除后会影响试题布局，确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          cardOperate.editPageData(Object.assign({}, this.msg, { edit: 2,gi:this.gi }));
        })
        .catch(() => {
          console.log("取消");
        });
    },
    closePopover() {
      this.popoverVisible = false;
    },
    submitPopover() {
      let curForm=null
      switch (this.msg.types) {
        case 1:
          if (this.objectiveForm.rowNum ==this.topicStoreroom[this.msg.topicIndex].typesItem.rowNum &&
          this.objectiveForm.diffLayout ==this.topicStoreroom[this.msg.topicIndex].typesItem.diffLayout) {
            this.closePopover();
            return;
          }
          curForm=this.objectiveForm
          break;
        case 2:
          if(!this.isFillChange){
            this.closePopover();
            return;
          }
          curForm=this.fillForm
          break;
        case 3:
          curForm=this.form346
          break;
      case 5:
          curForm=this.writingForm
          break
       case 4:
          curForm=this.form346
          break
       case 6:
          curForm=this.form346
          break
      }

      cardOperate.editPageData(
        Object.assign({}, this.msg, { edit: 3, formData: curForm,gi:this.gi })
      );
      console.log('curForm====log', curForm);
      debugger
      this.closePopover();o
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.line {
  border-bottom: 1px solid rgba(235, 235, 235, 1);
  padding-bottom: 10px;
}
.custom-edit-box {
  position: absolute;
  right: 10px;
  top: 42px;
  z-index: 3000;
}
.popover-cont {
  p {
    margin: 15px 0 0px;
    &:first-child {
      margin-top: 0;
    }
  }
}
.popo-text {
  padding-right: 10px;
}
</style>
